import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

type BulkAction = 'acceptAll' | 'declineAll';

interface ConsentBulkActionsProps {
  onAcceptAll: () => void;
  onDeclineAll: () => void;
  isDisabled?: boolean;
  isSaving?: boolean;
}

export function ConsentBulkActions({
  onAcceptAll,
  onDeclineAll,
  isDisabled = false,
  isSaving = false,
}: ConsentBulkActionsProps) {
  const { t } = useTranslation('clients');
  const [lastAction, setLastAction] = useState<BulkAction | null>(null);

  function acceptAll() {
    setLastAction('acceptAll');
    onAcceptAll();
  }

  function declineAll() {
    setLastAction('declineAll');
    onDeclineAll();
  }

  return (
    <div className="flex flex-wrap gap-2">
      <Button
        type="button"
        variant="outline"
        size="chip"
        disabled={isDisabled}
        isLoading={isSaving === true && lastAction === 'acceptAll'}
        onClick={acceptAll}
      >
        {t('portal.acceptAll')}
      </Button>
      <Button
        type="button"
        variant="outline"
        size="chip"
        disabled={isDisabled}
        isLoading={isSaving === true && lastAction === 'declineAll'}
        onClick={declineAll}
      >
        {t('portal.declineAll')}
      </Button>
    </div>
  );
}
